import { combineReducers } from "redux";
import movies from "./movies";
import { userReducer } from "./userReducer";
import { onlineUsersReducer } from "./onLineUserReducer";
import { authStatusReducer } from "./authStatus";

export default combineReducers({
  movies: movies,
  user: userReducer,
  onlineUsers: onlineUsersReducer,
  authStatus: authStatusReducer,
});
